import { render, staticRenderFns } from "./ModalDeleteProductComponent.vue?vue&type=template&id=f92df1ea"
import script from "./ModalDeleteProductComponent.vue?vue&type=script&lang=js"
export * from "./ModalDeleteProductComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports